import Dropdown from 'react-bootstrap/Dropdown'
import type { ThemeMode } from '../theme/theme'
import { useTheme } from '../theme/ThemeContext'

const VOLBY: { mode: ThemeMode; label: string; icon: string }[] = [
    { mode: 'light', label: 'Světlý', icon: 'bi-sun-fill' },
    { mode: 'dark', label: 'Tmavý', icon: 'bi-moon-stars-fill' },
    { mode: 'system', label: 'Podle systému', icon: 'bi-circle-half' },
]

export function ThemeToggle() {
    const { mode, theme, setMode } = useTheme()

    // Tlačítko ukazuje motiv, který je právě vidět - u volby "podle systému"
    // je tak poznat, jak se systém rozhodl.
    const buttonIcon = theme === 'dark' ? 'bi-moon-stars-fill' : 'bi-sun-fill'

    return (
        <Dropdown align="end">
            <Dropdown.Toggle
                variant="link"
                id="prepinac-motivu"
                className="su-theme-toggle su-tappable d-flex align-items-center justify-content-center text-white text-decoration-none px-2"
                aria-label="Vzhled aplikace"
                data-testid="prepinac-motivu"
            >
                <i className={`bi ${buttonIcon} fs-5`} aria-hidden="true" />
            </Dropdown.Toggle>

            <Dropdown.Menu>
                {VOLBY.map((volba) => (
                    <Dropdown.Item
                        key={volba.mode}
                        active={mode === volba.mode}
                        onClick={() => setMode(volba.mode)}
                        data-testid={`motiv-${volba.mode}`}
                    >
                        <i className={`bi ${volba.icon} me-2`} aria-hidden="true" />
                        {volba.label}
                    </Dropdown.Item>
                ))}
            </Dropdown.Menu>
        </Dropdown>
    )
}
